import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@tq/ui-components';

export type CharacterCountProps = {
  value: string | undefined;
  maxCount: number;
};
export const CharacterCount: React.FC<CharacterCountProps> = ({ value, maxCount }) => {
  const { t } = useTranslation('character_count');
  return (
    <Box mt={-4} mb={4}>
      {value?.length ?? 0} {t('of', 'of')} {maxCount} {t('characters', 'characters')}
    </Box>
  );
};
